"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeType = void 0;
var NodeType;
(function (NodeType) {
    NodeType["buttonGroup"] = "buttonGroup";
    NodeType["cardGroup"] = "cardGroup";
    NodeType["carousel"] = "carousel";
    NodeType["goTo"] = "goTo";
    NodeType["message"] = "message";
    NodeType["open"] = "open";
    NodeType["plugin"] = "plugin";
    NodeType["condition"] = "condition";
    NodeType["question"] = "question";
    NodeType["embedded"] = "embedded";
    NodeType["player"] = "player";
    NodeType["form"] = "form";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
